export default "__VITE_ASSET__DMiLk27l__"